<template>
  <div>
    <div class="row g-4 mb-4 align-items-stretch">
      <div :class="auth.status.loggedIn ? 'col-12' : 'col-12 col-lg-7'">
        <div class="hero rounded p-4 h-100">
          <div class="d-flex align-items-center mb-3">
            <img src="../assets/images/mkart_logo.jpg" width="48" class="rounded" alt="mKart" />
            <span class="ms-3 brandname">mKart</span>
          </div>
          <h1 class="h4">{{ hero.title }}</h1>
          <p class="text-muted mb-0">{{ hero.text }}</p>
        </div>
      </div>
      <div class="col-12 col-lg-5" v-if="!auth.status.loggedIn">
        <sign-up-sign-in></sign-up-sign-in>
      </div>
    </div>

    <platform-overview></platform-overview>
  </div>
</template>

<script>
import SignUpSignIn from "@/components//signUpSignIn/index.vue";
import PlatformOverview from "@/components/homepage/PlatformOverview.vue";

const heroContent = {
  en: {
    title: "Publish nautical charts here — sail with them at sea",
    text:
      "mKart has two sides. This web platform is where publishers upload ENCs and nautical data, set licenses and handle sales. The free mKart App is where navigators actually use those charts — sailing, browsing and exploring, online or offline."
  },
  ru: {
    title: "Публикуйте карты здесь — используйте их в море",
    text:
      "У mKart две стороны. Веб-платформа — для издателей: загрузка ЭНК и навигационных данных, лицензии и продажи. Бесплатное приложение mKart — для судоводителей: навигация, просмотр и исследование карт, онлайн и офлайн."
  }
};

export default {
  components: {
    SignUpSignIn,
    PlatformOverview
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    locale() {
      return this.$store.getters.locale;
    },
    hero() {
      return heroContent[this.locale.code] || heroContent.en;
    }
  }
};
</script>

<style scoped>
.hero {
  background-color: #e3f2fd;
}

.brandname {
  font-size: xx-large;
  font-weight: bold;
}
</style>
